"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBinary = void 0;
function isBinary(fileBuffer) {
    // The spec defines a binary file as anything containing a null byte
    return fileBuffer.includes(0);
}
exports.isBinary = isBinary;
//# sourceMappingURL=binary.js.map